export const BALANCES_PAGE = '/';
export const SUMMARY_PAGE = '/summary';
export const PLANT_PAGE = '/plant';
export const RETIRE_PAGE = '/retire';
export const DELEGATE_PAGE = '/delegate';
export const CERTIFICATES_PAGE = '/certificates';
export const RETIRE_ACTIVITY_PAGE = '/retire-activity';
export const ACTIVITY_PAGE = '/activity';
export const SIGNIN_PAGE = '/signin';
export const TERMS_PAGE = '/terms';
export const PRIVACY_PAGE = '/privacy';
export const NOT_FOUND_PAGE = '/404';

import config from 'config';
const { DASHBOARD_URL, /* COLLATERAL_URL, */ EXPLORER_URL, VALIDATION_URL } = config;

export const MAIN_MENU_ITEMS = [
  // {
  //   id: 'menu.collateral',
  //   href: COLLATERAL_URL,
  //   target: '_blank',
  //   text: 'Collateral'
  // },
  {
    id: 'menu.explorer',
    href: EXPLORER_URL,
    target: '_blank',
    text: 'Atlas'
  },
  {
    id: 'menu.dashboard',
    href: DASHBOARD_URL,
    target: '_blank',
    text: 'Dashboard'
  },
  {
    id: 'menu.validation',
    href: VALIDATION_URL,
    target: '_blank',
    text: 'Validation'
  }
];

export const NAV_LIST_ITEMS = [
  {
    id: 'menu.balances',
    to: BALANCES_PAGE,
    text: 'My Balances'
  },
  {
    id: 'menu.summary',
    to: SUMMARY_PAGE,
    text: 'Summary'
  },
  {
    id: 'menu.plant',
    to: PLANT_PAGE,
    text: 'Plant'
  },
  {
    id: 'menu.offset',
    to: RETIRE_PAGE,
    text: 'Retire'
  },
  {
    id: 'menu.activity',
    to: ACTIVITY_PAGE,
    text: 'Activity'
  }
  // {
  //   id: 'menu.delegate',
  //   to: DELEGATE_PAGE,
  //   text: 'Delegate'
  // }
];
